'use client';

import { c as _c } from "react/compiler-runtime";
import type { SingleSelectAnswer } from '@repo/contracts/cardfinder/funnel/types';
import { css } from '@repo/pandacss/css';
import { visuallyHidden } from '@repo/pandacss/patterns';
import { LoadingSpinner } from '@repo/ui/LoadingSpinner';
import { useAnswer } from '@/entities/answer/model/hooks';
import type { SingleSelectStep as SingleSelectStepConfig } from '@/shared/config/funnel/types';
import { useIsFunnelSubmitting } from '../../../model/Context/hooks';
import { FUNNEL_STEP_TITLE_ID } from '../../StepTitle';
import { choiceListClass, choiceListItemClass, getChoiceSetPositionProps } from '../choiceGroupA11y';
import { OptionCardContent } from './OptionCard';
import { optionCardClass, optionCardDisabledStyles, optionCardSelectedStyles } from './styles';
type SingleSelectInputProps = {
  step: SingleSelectStepConfig;
};
function isActivationKey(key: string) {
  return key === 'Enter' || key === ' ';
}
function requestFormSubmit(input: HTMLInputElement) {
  queueMicrotask(() => input.form?.requestSubmit());
}
export function SingleSelectInput(t0) {
  const $ = _c(29);
  const {
    step
  } = t0;
  const {
    value,
    setAnswer
  } = useAnswer(step.id);
  const isAutoAdvance = step.autoAdvance ?? false;
  const isSubmitting = useIsFunnelSubmitting();
  let t1;
  if ($[0] !== setAnswer) {
    t1 = next => {
      setAnswer(next);
    };
    $[0] = setAnswer;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== isSubmitting || $[3] !== setAnswer) {
    t2 = (next_0, input) => {
      if (isSubmitting) {
        return;
      }
      setAnswer(next_0);
      requestFormSubmit(input);
    };
    $[2] = isSubmitting;
    $[3] = setAnswer;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const commitSelection = t2;
  const t3 = isAutoAdvance ? "6" : "0";
  let t4;
  if ($[5] !== t3) {
    t4 = css({
      display: "flex",
      flexDirection: "column",
      gap: "2",
      mb: t3
    });
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== commitSelection || $[8] !== handleChange || $[9] !== isAutoAdvance || $[10] !== isSubmitting || $[11] !== step.id || $[12] !== step.options || $[13] !== value) {
    let t6;
    if ($[15] !== commitSelection || $[16] !== handleChange || $[17] !== isAutoAdvance || $[18] !== isSubmitting || $[19] !== step.id || $[20] !== step.options.length || $[21] !== value) {
      t6 = (option, index) => {
        const checked = value === option.value;
        let className = optionCardClass;
        if (checked) {
          className = `${optionCardClass} ${optionCardSelectedStyles}`;
        } else {
          if (isSubmitting) {
            className = `${optionCardClass} ${optionCardDisabledStyles}`;
          }
        }
        return <li key={option.value} className={choiceListItemClass}><label className={className} onClick={e => {
            e.currentTarget.focus();
            const input_0 = e.currentTarget.querySelector("input");
            if (!isAutoAdvance || e.detail === 0 || !input_0) {
              return;
            }
            commitSelection(option.value, input_0);
          }} onKeyDown={e_0 => {
            const input_1 = e_0.currentTarget.querySelector("input");
            if (!isAutoAdvance || !isActivationKey(e_0.key) || !input_1) {
              return;
            }
            e_0.preventDefault();
            commitSelection(option.value, input_1);
          }}><input type="radio" tabIndex={0} name={step.id} value={option.value} checked={checked} disabled={isSubmitting} {...getChoiceSetPositionProps(index, step.options.length)} onChange={() => handleChange(option.value)} onClick={_temp} className={visuallyHidden()} /><OptionCardContent iconHTML={option.icon} label={option.label} description={option.description} />{isAutoAdvance && checked && isSubmitting && <LoadingSpinner variant="blue" />}</label></li>;
      };
      $[15] = commitSelection;
      $[16] = handleChange;
      $[17] = isAutoAdvance;
      $[18] = isSubmitting;
      $[19] = step.id;
      $[20] = step.options.length;
      $[21] = value;
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    t5 = step.options.map(t6);
    $[7] = commitSelection;
    $[8] = handleChange;
    $[9] = isAutoAdvance;
    $[10] = isSubmitting;
    $[11] = step.id;
    $[12] = step.options;
    $[13] = value;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[23] !== t5) {
    t6 = <ul className={choiceListClass}>{t5}</ul>;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== isSubmitting || $[26] !== t4 || $[27] !== t6) {
    t7 = <div role="radiogroup" aria-busy={isSubmitting} aria-labelledby={FUNNEL_STEP_TITLE_ID} className={t4}>{t6}</div>;
    $[25] = isSubmitting;
    $[26] = t4;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
}
function _temp(e_1) {
  return e_1.stopPropagation();
}